import  Vue from 'vue'
import  App from './App.vue'
import  router from './router'
import 'vant/lib/index.css'


Vue.config.productionTip = false

import './assets/reset.css'


//vant的引入
import 'vant/lib/index.css'     //全局样式
import { Popup } from 'vant';  
Vue.use(Popup);                 //popup组件的单独引入


//pc/移动端自动跳转
import  {redirectByDevice}from  '@/js/common.js'
Vue.prototype.$redirectByDevice = redirectByDevice


//swiper引入
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
